import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    priority: { type: Number, default: 0 },
    queueable: { type: Boolean, default: false },
    autoShow: { type: Boolean, default: false },
    dismissible: { type: Boolean, default: true },
    backdropDismissible: { type: Boolean, default: true }
  }

  connect() {
    if (this.autoShowValue) {
      this.scheduleShow();
    }
  }

  disconnect() {
  }

  scheduleShow() {
    const delay = this.getShowDelay();
    
    setTimeout(() => {
      if (this.shouldShow()) {
        this.show();
      }
    }, delay);
  }

  getShowDelay() {
    return 500;
  }

  shouldShow() {
    return true;
  }

  show() {
    document.dispatchEvent(new CustomEvent('modal:show', {
      detail: {
        modalId: this.element.id,
        priority: this.priorityValue,
        queueable: this.queueableValue
      }
    }));
  }

  dismiss() {
    if (!this.dismissibleValue) {
      return;
    }

    this.element.classList.add('hidden');
    this.element.classList.remove('flex');
    
    document.dispatchEvent(new CustomEvent('modal:hide', {
      detail: { modalId: this.element.id }
    }));
    
    this.onDismiss();
  }

  clickOutside(event) {
    if (this.backdropDismissibleValue && event.target === this.element) {
      this.dismiss();
    }
  }

  handleEscape(event) {
    if (event.key === 'Escape' && this.dismissibleValue) {
      this.dismiss();
    }
  }
}
